export const enum Tabs {
  report = 'report',
  schede = 'contracts',
  teams = 'teams',
  campagne = 'campaigns',
  gestioneOperatori = 'teams configuration',
  gestioneCharities = 'charities configuration',
  posizioni = 'positions'
}
